"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createServerContext = exports.DataFetchContext = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _wait = _interopRequireWildcard(require("../../../../utils/wait"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var DataFetchContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.DataFetchContext = DataFetchContext;
var createServerContext = function createServerContext() {
  var dataFetchContext = {
    requests: [],
    allResolved: false
  };
  var Provider = function Provider(_a) {
    var children = _a.children;
    return (0, _jsxRuntime.jsx)(DataFetchContext.Provider, __assign({
      value: dataFetchContext
    }, {
      children: children
    }));
  };
  var _updatePromiseWithData = function _updatePromiseWithData(id, value) {
    dataFetchContext.requests = dataFetchContext.requests.map(function (request) {
      if (request.id === id) {
        return __assign(__assign({}, request), {
          data: value
        });
      } else {
        return request;
      }
    });
  };
  var resolveData = function resolveData(timeout, options) {
    if (timeout === void 0) {
      timeout = 1500;
    }
    return __awaiter(void 0, void 0, void 0, function () {
      var effects;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            effects = dataFetchContext.requests.map(function (effect) {
              if (timeout) {
                return Promise.race([effect.promise(options), (0, _wait.default)(timeout, _wait.WaitTypes.Reject)]).then(function (data) {
                  _updatePromiseWithData(effect.id, data);
                  return data;
                }).catch(function (error) {
                  _updatePromiseWithData(effect.id, error);
                  effect.cancel(error);
                });
              } else {
                return effect.promise(options).then(function (data) {
                  _updatePromiseWithData(effect.id, data);
                  return data;
                });
              }
            });
            return [4 /*yield*/, Promise.all(effects)];
          case 1:
            _a.sent();
            dataFetchContext.allResolved = true;
            return [2 /*return*/];
        }
      });
    });
  };

  var getRequests = function getRequests() {
    return dataFetchContext.requests;
  };
  return {
    Provider: Provider,
    resolveData: resolveData,
    getRequests: getRequests
  };
};
exports.createServerContext = createServerContext;